import React from 'react'

const InputField = ({
  type,
  isRequired,
  name,
  value,
  placeholder,
  onChange,
  readOnly,
  disable,
  size,
  className,
  error,
  icon
}) => {
  const sizeStyles = {
    small: 'py-2 px-3 text-sm',
    default: 'py-3 px-4',
    large: 'py-4 px-5 text-lg',
  };

  const currentSize = sizeStyles[size] || sizeStyles.default;

  return (
    <div className="relative">
      <input
        type={type}
        required={isRequired}
        name={name}
        readOnly={readOnly || disable}
        onChange={onChange}
        value={value}
        className={`
          w-full ${currentSize} rounded-xl
          ${icon ? 'pl-12' : ''}
          ${disable
            ? 'bg-surface-100 text-surface-500 cursor-not-allowed'
            : 'bg-white'
          }
          ${error
            ? 'border-danger-500 focus:ring-danger-500/20 focus:border-danger-500'
            : 'border-surface-200 focus:ring-primary-500/20 focus:border-primary-500'
          }
          border text-surface-700 placeholder:text-surface-400
          transition-all duration-200
          focus:outline-none focus:ring-2
          hover:border-surface-300
          ${className || ''}
        `}
        placeholder={placeholder}
      />
      {error && (
        <p className="mt-1.5 text-sm text-danger-500">{error}</p>
      )}
    </div>
  )
}

export default InputField
